var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42290",
    "data-name": "Group 42290",
    transform: "translate(-1272 -275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15851",
    "data-name": "Rectangle 15851",
    width: 24,
    height: 24,
    transform: "translate(1272 275)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "xls",
    transform: "translate(1276.148 276.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1_30_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37173",
    "data-name": "Path 37173",
    d: "M102.527,0h7.028L115.5,6.208V18.264A2.731,2.731,0,0,1,112.775,21H102.527A2.736,2.736,0,0,1,99.8,18.264V2.728A2.734,2.734,0,0,1,102.527,0Z",
    transform: "translate(-99.799 0)",
    fill: "rgba(6,167,125,0)",
    stroke: "#000",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_37180",
    "data-name": "Path 37180",
    d: "M0,0,6,6H0Z",
    transform: "translate(1286 277)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.278a2fe763a54ad17b7f5f51af8922e2.svg";
export { ForwardRef as ReactComponent };